import { render, staticRenderFns } from "./HibVsIdc.vue?vue&type=template&id=68902196&"
import script from "./HibVsIdc.vue?vue&type=script&lang=js&"
export * from "./HibVsIdc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports